/**
 * Runtime resolution of the Hive endpoint.
 *
 * CRA inlines `process.env.REACT_APP_*` into the bundle at BUILD time, which
 * meant one image per environment: the staging image hardcoded
 * https://hive.poweriot.ai and could not be reused on another server.
 *
 * Instead the container writes `/config.js` at startup (see docker-entrypoint.sh)
 * from the HIVE_URL env var, and that script sets `window.__KALIS_CONFIG__`
 * before the bundle loads. So the SAME image serves every environment and the
 * endpoint is per-server configuration.
 *
 * Resolution order:
 *   1. window.__KALIS_CONFIG__.hiveUrl  — injected by the container at runtime
 *   2. process.env.REACT_APP_SOCKET_URL — build-time value (local `npm start`)
 *   3. http://localhost:5150            — dev default
 */

declare global {
  interface Window {
    __KALIS_CONFIG__?: { hiveUrl?: string };
  }
}

const DEV_FALLBACK = 'http://localhost:5150';

/** Base URL of the Hive API / socket.io server, with no trailing slash. */
export function getHiveUrl(): string {
  const runtime =
    typeof window !== 'undefined' ? window.__KALIS_CONFIG__?.hiveUrl : undefined;

  // A placeholder that was never substituted must not be treated as a real URL.
  const resolved =
    (runtime && !runtime.startsWith('__') ? runtime : undefined) ??
    process.env.REACT_APP_SOCKET_URL ??
    DEV_FALLBACK;

  return resolved.replace(/\/+$/, '');
}

/** The resolved Hive base URL. Read once at module load, as the build-time value was. */
export const HIVE_URL = getHiveUrl();
